'use strict';

var resolvers = {
  round: {
    round: round
  },

  token: {
    token: token
  },

  basis: {
    round: round,
    basis: basis
  },

  distribution: {
    round: round,
    distribution: distribution
  },

  questionnaire: {
    token: token,
    step: step,
    questionnaire: questionnaire
  },

  summary: {
    summary: summary
  },

  intro: {
    intro: intro,
  },

  agreement: {
    questionnaire: {
      token: token,
      step: step,
      questionnaire: agreementQuestionnaire
    },

    summary: {
      summary: agreementSummary
    }
  },

  rounds: {
    rounds: listRound
  },

  invites: {
    round: round,
    invites: listInvite
  },

  overview: {
    invites: listInvitesAsCoworker
  }
};

function token($route) {
  return $route.current.params.token;
}

function step($route) {
  return parseInt($route.current.params.step);
}

function round($route) {
  return parseInt($route.current.params.round);
}

function basis($route, performanceReviewService) {
  return performanceReviewService.retrieve.basis(round($route));
}

function distribution($route, performanceReviewService) {
  return performanceReviewService.retrieve.distribution(round($route));
}

function questionnaire($route, performanceReviewService) {
  return performanceReviewService.retrieve.questionnaire(token($route), step($route));
}

function agreementQuestionnaire($route, performanceReviewService) {
  return performanceReviewService.retrieve.agreement.questionnaire(token($route), step($route));
}

function summary($route, performanceReviewService) {
  return performanceReviewService.retrieve.summary(token($route));
}

function intro($route, performanceReviewService) {
  return performanceReviewService.retrieve.intro(token($route));
}

function agreementSummary($route, performanceReviewService) {
  return performanceReviewService.retrieve.agreement.summary(token($route));
}

function listRound(performanceReviewService) {
  return performanceReviewService.list.round();
}

function listInvite($route, performanceReviewService) {
  return performanceReviewService.list.invite(round($route));
}

function listInvitesAsCoworker(performanceReviewService) {
  return performanceReviewService.list.invitesAsCoworker();
}

module.exports = resolvers;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/performance-review/resolve/index.js
 ** module id = 319
 ** module chunks = 0
 **/